var app = angular.module('leonardo');

var PortfolioSelector = function(PortfolioService, $rootScope, $q) {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    templateUrl: 'views/templates/widget/portfolio-selector.html',
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      inline: '@',
      account: '=?',
      name:'@'
    },
    link: function (scope, element, attrs, ctrls) {
      scope.multiple = attrs.multiple ? true : false;
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];
      scope.value_aux = [];

      if (!isNull(scope.account)) {
        PortfolioService.getlist({disable_pagination: true, account: scope.account, essential: true}).then(function(data){
          scope.portfolios = data;
        });
      }
      else {
        scope.portfolios = (PortfolioService.getCollection().length > 0) ?
          PortfolioService.getCollection() : PortfolioService.getAll({not_empty: true, essential: true}).$object;
      }

      scope.ngModelCtrl.$render = function() {
        scope.value = scope.ngModelCtrl.$modelValue;
        if (scope.value && angular.isArray(scope.value)) {
          scope.value_aux = scope.value.join(',');
        }
        else {
          scope.value_aux = angular.copy(scope.value);
        }
      };

      scope.$watch('value', function (newValue) {
        scope.ngModelCtrl.$setViewValue(newValue);
      });

      scope.togglePortfolio = function(portfolio) {
        if (scope.multiple) {
          if (!scope.value) {
            scope.value = [];
          }
          var index = scope.value.indexOf(portfolio.id);
          if (index >= 0) {
            scope.value.splice(index, 1);
          }
          else {
            scope.value.push(portfolio.id);
          }
          scope.value_aux = scope.value.join(',');
        }
        else {
          scope.value = portfolio.id;
          scope.value_aux = angular.copy(scope.value);
        }
        scope.ngModelCtrl.$setViewValue(scope.value);
      };

      scope.isSelected = function(portfolio) {
        if (scope.multiple) {
          return (_.contains(scope.value, portfolio.id));
        }
        else {
          return (portfolio.id == scope.value);
        }
      };

      scope.$on('selector-account:updated', function($event, account){
        scope.account = account;
        if (scope.account !== null || scope.account !== undefined || scope.account !== '') {
          PortfolioService.getlist({disable_pagination: true, account: scope.account, essential: true}).then(function(data){
            scope.portfolios = data;
          });
        }
        else {
          scope.portfolios = (PortfolioService.getCollection().length > 0) ?
            PortfolioService.getCollection() : PortfolioService.getAll({not_empty: true, essential: true}).$object;
        }
      });

      scope.ngModelCtrl.$validators.required = function(modelValue) {
        if (!scope.required) {
          return true;
        }
        if(modelValue) {
          if (angular.isArray(modelValue)) {
            return (modelValue.length > 0);
          }
          else {
            return !isNull(modelValue);
          }
        }
        return false;
      };

    }
  };
};

app.directive('portfolioSelector', ['PortfolioService', '$rootScope', '$q', PortfolioSelector]);
